import { UnicodeEntity } from '@mews/enums';
import { Date } from '@mews/framework';
import { Typography, Stack } from '@optimus-web/core';
import { Account } from '@mews-commander/data-access';
import { isDefined } from '@mews/std';
import { AccountName } from '../../../../components/common/AccountName';
import { ProductCheckListDataRow } from '../../types';
import { ProductCheckListDataTestIds } from '../../constants';
import { BirthDayIcon } from './BirthDayIcon';

interface GuestsCellProps {
    row: ProductCheckListDataRow;
    reportFilterDate: Date;
    active?: boolean;
}

export const GuestsCell: React.FC<GuestsCellProps> = ({ row, reportFilterDate, active = true }) => {
    const guests: Account[] = row.reservation ? row.guests : [row.owner].filter(isDefined);

    if (!guests.length) {
        return <span data-test-id={ProductCheckListDataTestIds.cellGuests}>{UnicodeEntity.Dash}</span>;
    }

    return (
        <Stack vertical data-test-id={ProductCheckListDataTestIds.cellGuests}>
            {guests.map((guest) => (
                <Stack spacing="100" itemAlignment="center">
                    <Typography
                        textStyle="bodyMediumStrong"
                        key={guest.id}
                        variant={!active ? 'tertiary' : 'primary'}
                        data-test-id={ProductCheckListDataTestIds.guest}
                        data-test-guest-id={guest.id}
                        as="div"
                    >
                        <AccountName account={guest} reverse />
                    </Typography>
                    <BirthDayIcon account={guest} reportFilterDate={reportFilterDate} />
                </Stack>
            ))}
        </Stack>
    );
};
